import { render, staticRenderFns } from "./HorizontalNavMenuItemsUserControls.vue?vue&type=template&id=09c46f5d&"
import script from "./HorizontalNavMenuItemsUserControls.vue?vue&type=script&lang=js&"
export * from "./HorizontalNavMenuItemsUserControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports